import { createReducer } from 'typesafe-actions';
import { type AssetPickerActions, closeAssetPicker, openAssetPicker, toggleAssetPickerSortMenuOpen } from './actions';
import type { NAME } from './constants';

export type AssetPickerState = {
  sortMenuOpen: boolean;
  isOpen: boolean;
};

export type AssetPickerSlice = {
  [NAME]: AssetPickerState;
};

export const initialAssetPickerState: AssetPickerState = {
  sortMenuOpen: false,
  isOpen: false
};

export default createReducer<AssetPickerState, AssetPickerActions>(initialAssetPickerState)
  .handleAction(toggleAssetPickerSortMenuOpen, (state) => ({
    ...state,
    sortMenuOpen: !state.sortMenuOpen
  }))
  .handleAction(openAssetPicker, (state) => ({ ...state, isOpen: true }))
  .handleAction(closeAssetPicker, (state) => ({ ...state, isOpen: false }));
